import {all} from 'redux-saga/effects';
import etlDashboardSaga from 'SystemAdministration/sagas/etlDashboardSaga';

export default function*() {
  yield all([etlDashboardSaga()]);
}
